const LOCAL_STORAGE_KEY = 'personalizationSettings';

const EMPTY_VALUE = {
  notInterestedIn: {
    categories: [],
  },
};

export const readPersonalizationSettings = () => {
  if (IS_SERVER) {
    // This data is not available on the server
    return EMPTY_VALUE;
  }

  try {
    const jsonString = window.localStorage.getItem(LOCAL_STORAGE_KEY);
    if (!jsonString) {
      return EMPTY_VALUE;
    }
    const data = JSON.parse(jsonString);
    return data !== null && typeof data === 'object' ? data : EMPTY_VALUE;
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn(
        'Could not parse personalization settings from localStorage:',
        e
      );
    }

    return EMPTY_VALUE;
  }
};

export const writePersonalizationSettings = data => {
  const jsonString = JSON.stringify(data);
  localStorage.setItem(LOCAL_STORAGE_KEY, jsonString);
};
